import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { update, store } from '../../redux/ActionsAndReducers/BaseFunction';

import BaseDetails from './BaseDetails';

const PartnerDetails = ({
  data, columns, _updatePartner, _storeDataToSave, forCreate,
}) => (
  <BaseDetails
    data={data}
    columns={columns}
    update={_updatePartner}
    store={_storeDataToSave}
    forCreate={forCreate}
    keyId="partnersId"
    model="partners"
  />
);

PartnerDetails.defaultProps = {
  columns: [],
  forCreate: false,
};

PartnerDetails.propTypes = {
  data: PropTypes.shape({}).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  _updatePartner: PropTypes.func.isRequired,
  _storeDataToSave: PropTypes.func.isRequired,
  forCreate: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  _updatePartner: (id, key, value) => dispatch(update('partners', id, key, value)),
  _storeDataToSave: (id, key, value) => dispatch(store('partners', id, key, value)),
});


export default connect(null, mapDispatchToProps)(PartnerDetails);
